import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  Box,
  Button,
  Collapse,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";

const useStyles = makeStyles((theme) => ({
  submitButton: {
    backgroundColor: "#1565C0",
    color: "#ffffff",
    textTransform: "none",
    fontSize: "1rem",
    fontWeight: 500,
    padding: "12px",
    "&:hover": {
      backgroundColor: "#0d47a1",
    },
  },
  cancelButton: {
    color: "#1565C0",
    textTransform: "none",
    padding: 0,
    fontSize: "1rem",
    "&:hover": {
      backgroundColor: "transparent",
      textDecoration: "underline",
    },
  },
}));

const ForgotPasswordForm = ({
  onSubmit,
  classes,
  errorMessage,
  open,
  setErrorMessage,
  handleChangeLocation,
}) => {
  const formClasses = useStyles();

  return (
  <Formik
    initialValues={{ email: "" }}
    validationSchema={Yup.object().shape({
      email: Yup.string()
        .email("Must be a valid email.")
        .max(255)
        .required("Email is required."),
    })}
    onSubmit={onSubmit}
  >
    {({
      errors,
      handleBlur,
      handleChange,
      handleSubmit,
      touched,
      values,
      isValid,
      dirty,
    }) => (
      <form noValidate onSubmit={handleSubmit} className={classes.formStyle}>
        {errorMessage && open && (
          <Box mb={2}>
            <Collapse in={open}>
              <Alert severity="error" variant="filled">
                <Typography variant="body1">{errorMessage}</Typography>
              </Alert>
            </Collapse>
          </Box>
        )}
        <Box mb={2}>
          <Typography variant="body2" style={{ marginBottom: "8px", color: "#424242", fontSize: "0.875rem" }}>
            Email Address
          </Typography>
          <TextField
            error={Boolean(touched.email && errors.email)}
            fullWidth
            helperText={touched.email && errors.email}
            placeholder="Enter email address"
            name="email"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.email}
            variant="outlined"
          />
        </Box>
        <Box mt={3}>
          <Button
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            className={formClasses.submitButton}
            disabled={!isValid || !dirty}
          >
            Send Reset Code
          </Button>
        </Box>
        <Box mt={2} textAlign="center">
          <Button
            onClick={() => handleChangeLocation("login")}
            className={formClasses.cancelButton}
          >
            Back to Login
          </Button>
        </Box>
      </form>
    )}
  </Formik>
  );
};

export default ForgotPasswordForm;
